import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import DependentsOverview from '../../../../components/FormDescriptions/DependentsOverview';
import { emptyObjectSchema } from '../../../../definitions';
import content from '../../../../locales/en/content.json';

export default {
  uiSchema: {
    ...titleUI(content['dependent-info--overview-title']),
    ...descriptionUI(DependentsOverview),
  },
  schema: emptyObjectSchema,
};
